<template>
  <el-dialog
    title="Crear Solicitud"
    :visible.sync="showDialogVisible"
    width="35%"
    :before-close="handleClose"
  >
    <el-form
      :model="model"
      :rules="rules"
      ref="newRequestForm"
      label-width="150px"
      class="demo-ruleForm"
      label-position="left"
    >
      <el-form-item label="Cliente" prop="ClientName">
        <el-input v-model="model.ClientName" disabled />
      </el-form-item>

      <el-form-item label="Empresa" prop="CompanyCode">
        <el-input v-model="model.CompanyCode" disabled />
      </el-form-item>

      <el-form-item label="RNC / Cedula" prop="CustomerIdentification">
        <el-input v-model="model.CustomerIdentification" disabled />
      </el-form-item>

      <el-form-item label="Tipo de solicitud" prop="ServiceRequestTypeId">
        <el-select
          v-model="model.ServiceRequestTypeId"
          placeholder="Tipo de interaccion"
          clearable
          filterable
        >
          <el-option
            v-for="item in list_types_to_select"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="Producto" prop="ProductId">
        <el-select
          clearable
          filterable
          default-first-option
          v-model="model.ProductId"
          placeholder="Producto"
        >
          <el-option
            v-for="item in list_products"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="Inciada por" prop="InitiatedBy">
        <el-select
          v-model="model.InitiatedBy"
          placeholder="Inciada por"
          clearable
          filterable
        >
          <el-option
            v-for="item in InitiatedByItems"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="Contacto" prop="ContactCode">
        <el-select
          v-model="model.ContactCode"
          placeholder="Contacto"
          clearable
          filterable
        >
          <!-- <el-option
            v-for="(item, index) in list_contact"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option> -->
          <el-option
            v-for="item in contactByProspect"
            :key="item.ContactCode"
            :value="item.ContactCode"
            :label="item.Name"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="Comentario" prop="Comments">
        <el-input v-model="model.Comments" type="textarea"></el-input>
      </el-form-item>
      <el-form-item label="Adjunto">
        <el-upload
          ref="upload"
          class="upload-demo"
          drag
          action="/api/serviceRequests/UploadFile"
          :multiple="false"
          :limit="1"
          :headers="headers"
          :auto-upload="false"
          :on-exceed="handleExceed"
          :data="dataToUpload"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            Suelta tu archivo aquí o <em>haz clic para cargar</em>
          </div>
        </el-upload>
      </el-form-item>

      <template>
        <div style="margin-bottom: 10px">
          <el-button @click="addNewDevice">Agregar dispotivo</el-button>
        </div>
        <el-table
          border
          :data="model.DeviceTypes"
          empty-text="No ha seleccionado dispotivo"
        >
          <el-table-column type="index"></el-table-column>
          <el-table-column label="Dispotivo" prop="DeviceTypeId">
            <template slot-scope="scope">
              <el-select v-model="scope.row.DeviceTypeId">
                <el-option
                  v-for="(item, index) in DeviceTypesHardCode"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="Cantidad" prop="Quantity">
            <template slot-scope="scope">
              <el-input-number v-model="scope.row.Quantity" :min="0" />
            </template>
          </el-table-column>
          <el-table-column label="" width="90" align="center">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="danger"
                @click="handleDelete(scope.$index)"
                ><i class="el-icon-close"></i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submitForm('newRequestForm')"
        >Crear</el-button
      >
      <el-button @click="resetForm('newRequestForm')">Cancelar</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "NewRequestProspect",
  data() {
    return {
      contactByProspect: "",
      fileName: "",
      dataToUpload: {
        id: 0
      },
      showDialogVisible: false,
      fileList: [],
      InitiatedByItems: [
        {
          label: "Tennos Business",
          value: 0,
          IsEnable: true
        },
        {
          label: "Cliente / Contacto",
          value: 1,
          IsEnable: true
        }
      ],
      model: {
        ClientName: "",
        ClientCode: "",
        CustomerIdentification: "",
        CompanyCode: "",
        Comments: "",
        ServiceRequestTypeId: "",
        ProductId: "",
        InitiatedBy: 0,
        ContactCode: "",
        DeviceTypes: []
      },
      rules: {
        ServiceRequestTypeId: [{ required: true }],
        ProductId: [{ required: true }],
        InitiatedBy: [{ required: true }],
        ContactCode: [{ required: true }],
        Comments: [{ required: true }],
        ClientCode: [{ required: true }],
        ClientName: [{ required: true }],
        CustomerIdentification: [{ required: true }],
        CompanyCode: [{ required: true }]
      },
      clientCode: "",
      contactCode: "",
      currentClient: {},
      headers: {
        Authorization: `Bearer ${this.$store.state.auth.token}`
      },
      uploadSuccess: false,
      companyId: this.$store.state.user.user.CompanySelected,
      DeviceTypesHardCode: [
        {
          label: "TERMINAL",
          value: 1,
          IsEnable: true
        },
        {
          label: "GPS",
          value: 2,
          IsEnable: true
        },
        {
          label: "Plásticos",
          value: 3,
          IsEnable: true
        },
        {
          label: "TERMINAL SIN SIM",
          value: 4,
          IsEnable: true
        },
        {
          label: "GPS CELULAR",
          value: 6,
          IsEnable: true
        },
        {
          label: "PUNTO WEB",
          value: 7,
          IsEnable: true
        },
        {
          label: "MVIEW",
          value: 8,
          IsEnable: true
        },
        {
          label: "Activación de Software",
          value: 9,
          IsEnable: true
        }
      ]
    };
  },
  computed: {
    ...mapGetters({
      list_contact: "contact/list_to_select",
      list_types_to_select: "request_types/list_to_select",
      list_products: "products/list_products"
    })
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const { UserID, CompanySelected } = this.currentUser;

          const new_request = {
            ...this.model,
            AttachmentFileName: "string",
            ServiceIsFree: true,
            Target: 0,
            UserId: UserID,
            CompanyCode: CompanySelected,
            ContactName: "",
            ContactEmail: "",
            IsProspect: true
          };

          this.$store
            .dispatch("technical_support/create_request", new_request)
            .then(() => {
              this.showDialogVisible = false;
              //this.dataToUpload.id = resp.data.Message.split("=")[1];  -> Esta sentencia causa un error al compilarla "split no funciona con null"
              this.$refs.upload.submit();
              this.$message({
                type: "success",
                message: "Solicitud creada"
              });
              this.resetForm(formName);
              this.$refs["newRequestForm"].resetFields();
            });
          this.resetForm(formName);
        } else {
          this.resetForm(formName);
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.showDialogVisible = false;
      this.model.DeviceTypes = [];
    },
    handleClose(done) {
      this.$refs["newRequestForm"].resetFields();
      done();
    },
    show(clientCode, currentClient) {
      this.clientCode = clientCode;
      this.currentClient = currentClient;
      this.model.ClientName = currentClient.Name;
      this.model.ClientCode = clientCode;
      this.model.CustomerIdentification = currentClient.VatRegistrationNumber;
      this.model.CompanyCode = currentClient.CompanyId;
      this.showDialogVisible = true;
      this.GetcontactByProspect();
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `El límite es 1, haz seleccionado ${files.length + fileList.length}`
      );
    },
    addNewDevice() {
      this.model.DeviceTypes.push({ DeviceTypeId: null, Quantity: null });
    },
    handleDelete(index) {
      this.model.DeviceTypes.splice(index, 1);
    },
    GetcontactByProspect() {
      this.$http
        .get(
          `/api/serviceRequests/GetContactByProspect?companyCode=${this.companyId}&contactCode=${this.clientCode}`
        )
        .then((resp) => {
          const contacts = resp.data.map((i) => {
            return { ContactCode: i.Id, Name: i.FullName };
          });
          this.contactByProspect = contacts;
        })
        .catch((err) => {
          this.$alert(err.message, err.name, {
            type: "error"
          });
        });
    }
  }
};
</script>

<style></style>
